/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Divider, Grid, ProductCard, Typography, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/coding-challenges';

const styles = {
  titleText: css`
    margin-bottom: 40px;
  `,
  sections: css`
    padding: 20px;
    align-items: center;
    width: 33.33%;
  `,
  productCards: css`
    text-align: center;
    text-justify: inter-word;
    align-items: center;
    padding: 15px;
  `,
  highlightText: css`
    color: var(--cds-color-blue-700);
    padding: 15px;
    text-align: center;
    text-justify: inter-word;
  `,
  cardsCenter: css`
    justify-content: center;
    width: 100%;
  `,
};
// md={3} sm={6} xs={12}

const LandingPageHowItWorks = () => {
  return (
    <div>
      <Typography variant="h1semibold" css={styles.titleText}>
        {_t('How It Works')}
      </Typography>
      <Grid container css={styles.cardsCenter}>
        <Grid item css={styles.sections}>
          <ProductCard
            variant="grid"
            width="100%"
            productType="competitionRules"
            body={
              <div css={styles.productCards}>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line
                    x1="33.6001"
                    y1="25.6"
                    x2="6.4001"
                    y2="25.6"
                    stroke="var(--cds-color-blue-700)"
                    strokeWidth="3.2"
                  />
                  <rect
                    x="5.2"
                    y="5.99999"
                    width="29.6"
                    height="22.4"
                    rx="2.8"
                    stroke="var(--cds-color-blue-700)"
                    strokeWidth="2.4"
                  />
                  <circle cx="19.9999" cy="26.4" r="1.6" fill="white" />
                  <rect x="12" y="32" width="16" height="3.2" rx="1.6" fill="var(--cds-color-blue-700)" />
                  <path
                    d="M14.3999 15.6L18.2485 19.0987C18.5591 19.3811 19.0353 19.3753 19.339 19.0854L27.5999 11.2"
                    stroke="var(--cds-color-blue-700)"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <Typography css={styles.productCards} variant="h2semibold">
                  {_t('1. Register')}
                </Typography>
                <Typography2 component="p" css={styles.productCards} variant="bodyPrimary">
                  {_t(
                    "To register, click the link above. If you register by August 29th, you'll receive a reminder email on the day the challenge starts."
                  )}
                </Typography2>
                <Divider />
                <Typography2 component="p" css={styles.highlightText} variant="bodyPrimary">
                  {_t('Register between now and August 29th')}
                </Typography2>
              </div>
            }
          />
        </Grid>
        <Grid item css={styles.sections}>
          <ProductCard
            variant="grid"
            productType="competitionRules"
            body={
              <div css={styles.productCards}>
                <svg width="28" height="31" viewBox="0 0 28 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="4.62866" y="10.5143" width="1.71429" height="1.71429" fill="var(--cds-color-blue-700)" />
                  <rect x="4.62866" y="18.7429" width="1.71429" height="1.71429" fill="var(--cds-color-blue-700)" />
                  <rect x="4.62866" y="14.6286" width="1.71429" height="1.71429" fill="var(--cds-color-blue-700)" />
                  <rect x="8.74292" y="10.5143" width="6.17143" height="1.71429" fill="var(--cds-color-blue-700)" />
                  <rect x="8.74292" y="18.7429" width="2.74286" height="1.71429" fill="var(--cds-color-blue-700)" />
                  <rect x="8.74292" y="14.6286" width="6.17143" height="1.71429" fill="var(--cds-color-blue-700)" />
                  <path
                    d="M11.1428 27.3143H1.19995V1.60001H13.8857L20.0571 7.42858V13.9429"
                    stroke="var(--cds-color-blue-700)"
                    strokeWidth="2.05714"
                  />
                  <path
                    d="M13.6777 19.8619C12.9532 21.2466 12.6989 22.8294 12.9531 24.3714C13.2073 25.9133 13.9564 27.3307 15.0871 28.4095C16.2178 29.4882 17.6688 30.1698 19.2211 30.3513C20.7733 30.5328 22.3424 30.2043 23.6914 29.4155C25.0405 28.6267 26.0963 27.4203 26.6994 25.9786C27.3025 24.5369 27.4202 22.9381 27.0346 21.4236C26.649 19.9092 25.7812 18.5613 24.5621 17.5835C23.343 16.6057 21.8389 16.0511 20.2768 16.0034L20.2165 17.9809C21.3493 18.0155 22.4401 18.4177 23.3242 19.1268C24.2083 19.8359 24.8377 20.8134 25.1173 21.9118C25.3969 23.0101 25.3116 24.1695 24.8742 25.2151C24.4369 26.2607 23.6712 27.1355 22.6928 27.7076C21.7144 28.2797 20.5765 28.5179 19.4508 28.3863C18.3251 28.2546 17.2728 27.7604 16.4528 26.978C15.6328 26.1957 15.0896 25.1678 14.9052 24.0495C14.7208 22.9313 14.9053 21.7834 15.4307 20.7792L13.6777 19.8619Z"
                    fill="var(--cds-color-blue-700)"
                  />
                  <path
                    d="M13.6777 19.8619C12.9532 21.2466 12.6989 22.8294 12.9531 24.3714C13.2073 25.9133 13.9564 27.3307 15.0871 28.4095C16.2178 29.4882 17.6688 30.1698 19.2211 30.3513C20.7733 30.5328 22.3424 30.2043 23.6914 29.4155C25.0405 28.6267 26.0963 27.4203 26.6994 25.9786C27.3025 24.5369 27.4202 22.9381 27.0346 21.4236C26.649 19.9092 25.7812 18.5613 24.5621 17.5835C23.343 16.6057 21.8389 16.0511 20.2768 16.0034L20.2165 17.9809C21.3493 18.0155 22.4401 18.4177 23.3242 19.1268C24.2083 19.8359 24.8377 20.8134 25.1173 21.9118C25.3969 23.0101 25.3116 24.1695 24.8742 25.2151C24.4369 26.2607 23.6712 27.1355 22.6928 27.7076C21.7144 28.2797 20.5765 28.5179 19.4508 28.3863C18.3251 28.2546 17.2728 27.7604 16.4528 26.978C15.6328 26.1957 15.0896 25.1678 14.9052 24.0495C14.7208 22.9313 14.9053 21.7834 15.4307 20.7792L13.6777 19.8619Z"
                    fill="var(--cds-color-blue-700)"
                  />
                  <line
                    x1="20.176"
                    y1="23.3511"
                    x2="17.5016"
                    y2="21.8119"
                    stroke="var(--cds-color-blue-700)"
                    strokeWidth="1.71429"
                    strokeLinecap="round"
                  />
                  <line
                    x1="13.8857"
                    y1="1.60004"
                    x2="13.8857"
                    y2="8.45718"
                    stroke="var(--cds-color-blue-700)"
                    strokeWidth="2.05714"
                  />
                  <line
                    x1="12.8572"
                    y1="7.42858"
                    x2="19.0286"
                    y2="7.42858"
                    stroke="var(--cds-color-blue-700)"
                    strokeWidth="2.05714"
                  />
                  <circle cx="20.4" cy="23.5429" r="1.37143" fill="var(--cds-color-blue-700)" />
                </svg>

                <Typography css={styles.productCards} variant="h2semibold">
                  {_t('2. Complete Challenge')}
                </Typography>
                <Typography2 component="p" css={styles.productCards} variant="bodyPrimary">
                  {_t(
                    'In this challenge, you will build a prediction or classification model using Python in a Jupyter Notebook with a real-world dataset. You can improve and submit your model as many times as you wish until the deadline to try and achieve the best score.'
                  )}
                </Typography2>
                <Divider />
                <Typography2 component="p" css={styles.highlightText} variant="bodyPrimary">
                  {_t('The challenge starts August 29th, 8 am PST and ends August 31st, 11:59 pm PST')}
                </Typography2>
              </div>
            }
          />{' '}
        </Grid>
        <Grid item css={styles.sections}>
          <ProductCard
            variant="grid"
            productType="competitionRules"
            body={
              <div css={styles.productCards}>
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <rect width="40" height="40" fill="url(#pattern0)" />
                  <defs>
                    <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                      <use xlinkHref="#image0_21_228" transform="scale(0.0111111)" />
                    </pattern>
                    <image
                      id="image0_21_228"
                      width="90"
                      height="90"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEJUlEQVR4nO1dyW4TQRAtciAK4gPCcmD5CeDAdsqBS5C6zEcAUhLuOSIhBIhFJBzCXyD2oxESyOmyCSh3LiFAIIRwM+p2DJIzM+4Zz7iry/2kktBk6Hnv0e7umooLgBCAzXOA9AhQfwRFv2yYPyMtQq151je98FFrHgekV4DUzgxFL0AtH/VNN0zUmqcA9Xpfk/+b/QUUnfRNOyzUGkcAac3Z5H+h1+2nIMIRil7mN7k7s/Vr18eMNtTy+cImdyNukA6wp4vEmboNSs+Aak3C9MoBUDRrryXfu+DyqNEG0qcU82YS7p1LuXfFC/eggHoz2bzW5K57zbXkTfEniEdvcjHoeos7YZaLXphrZY0fTBLkmlxgYSNmdz1TNa9V+DyGSVDe5AKLCDebIc3aWdyZyXOA+k+1z+SUBBVOLiiQ4JIEDZJcYCDhPQkqI7nAQMLrBumSXOQ9xmGVkXHsY50E5UkueoH0duhGK3rjwIthEmRmSCKpjJnchaKrHoy+DP2Qejb3mQSlCXLB1Oo4KL08xGWjAaq1t3JdlWBQQtP68HDMNiY3Dg1NV+kog9DU6jggXbHrZ6kbpBlL1+1y4TqTy9RVKtgRkqqLHSGputgRkqqLHSGputgRkqqLHSGputgRkqqLHSGputgRkqqLHSGputgRkqqLHSGputgRynwlexNQfwWkLfu7G6o+EY4udoTSTKYnCTwXIRhd7Ag5m5xdMWGnKy+hC+/2gaIHgLSR+nfT4zsg3c/8yOcbf6M0XZUjLyGlFwoY7F6Nzjf+rdJ0VY48hObbY4D0e2CjzWZmxhpkfLOcmGWlDF1DQYhGqz4m59UldulA/bDw+C4mF9HFz+j6BKC+t7Ox5TNY0TdQ+m7mZpg2vqLPgPq6k8lFdFUOdoSk6mJHSKoudoSk6mJHSKoudoSk6mJHSKoudoSk6mJHSKoudoSk6uJGSJnMkBY7VRT7vccbNhuMFZaS0TF59/uNWGEpE+09+X6RPVZY2oUrLGlfXkqOWGGBwhUWup3D6FhhgSIv/vsWY3vW7VhhoWg0+woL2pf+rmPdEWx0vboKS6dmuJXjH2zTnlTK0FU5OBGab4+lfmE+eVPdTl3rOeliSQjpceLGl7RBKr0UjC52hFRrvzXbzmy9aY973RTcrMn2mm1xsWTvDUUXP0JdpKy99nrazzjrYkdIqi52hKTqYkdIqi52hKTqYkdIqi52hKTqYkdIqi52hKTqGqQdG1dcen8wWZP+wbDBYEIL4lCQ1irZb4PBhKpzbwviUDDdr1VyxnvwIXU/b49G6NP+jLZm6+f+TaBqQ9FT8I5RaNR9kY4BC5j27KZNu3dTqOxYA9QngBXMfzwgaRlR+pn9tLKFojO22m2OQ16acdMgvUw/2NOF940vIiIiIiIiIiIiIiIChoe/+fK9yE6VHgoAAAAASUVORK5CYII="
                    />
                  </defs>
                </svg>

                <Typography css={styles.productCards} variant="h2semibold">
                  {_t('3. Winners Awarded')}
                </Typography>
                <Typography2 component="p" css={styles.productCards} variant="bodyPrimary">
                  {_t('The winners will be determined based on the accuracy of their model predictions.')}
                </Typography2>
                <Divider />
                <Typography2 component="p" css={styles.highlightText} variant="bodyPrimary">
                  {/* eslint-disable-next-line no-restricted-syntax */}
                  {_t('Winners will be notified by email the week of September 10th')}
                </Typography2>
              </div>
            }
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default LandingPageHowItWorks;
